import { FC, useState } from "react";
import { Stack } from "@shopify/polaris";
import { SubscriptionPlan } from "@prisma/client";

import PlanCard from "./components/PlanCard/PlanCard.jsx";
import ChangePriceButtons from "../ChangePriceButtons/ChangePriceButtons.jsx";
import { sortedPlans } from "../../../../utils/sortedPlans.js";
import { EVERY_30_DAYS } from "../../../../../constants/subscriptionInterval.js";
import { useAppSelector } from "../../../../hooks/redux.js";
import styles from "./PlanCards.module.css";

interface PlanCardsProps {
  plans: (SubscriptionPlan & { isCustom?: boolean })[],
}

const PlanCards: FC<PlanCardsProps> = ({ plans }) => {
  const shopifyAppSubscriptionInterval = useAppSelector((state) => state?.shop?.data?.shopifyAppSubscription?.lineItems[0]?.plan?.pricingDetails?.interval);
  const [subscriptionInterval, setSubscriptionInterval] = useState(shopifyAppSubscriptionInterval || EVERY_30_DAYS);

  return (
    <div className={styles["plansSection"]}>
      <Stack vertical distribution="fill">
        <ChangePriceButtons
          subscriptionInterval={subscriptionInterval}
          setSubscriptionInterval={setSubscriptionInterval}
        />
        <div className={styles.cardsWrapper}>
          {
            plans && sortedPlans(plans).map((plan: SubscriptionPlan & { isCustom?: boolean }) => {
              return (
                <PlanCard
                  key={plan.id}
                  plan={plan}
                  subscriptionInterval={subscriptionInterval}
                  shopifyAppSubscriptionInterval={shopifyAppSubscriptionInterval}
                />
              );
            })
          }
        </div>
      </Stack>
    </div>

  );
};

export default PlanCards;